import { useEffect, useState } from 'react'

type InstallPromptEvent = Event & { prompt:()=>Promise<void>; userChoice:Promise<{outcome:'accepted'|'dismissed'}> }

export function PwaInstallButton(){
 const[installEvent,setInstallEvent]=useState<InstallPromptEvent|null>(null)
 const[installed,setInstalled]=useState(()=>window.matchMedia?.('(display-mode: standalone)').matches===true)
 useEffect(()=>{
  const onPrompt=(event:Event)=>{event.preventDefault();setInstallEvent(event as InstallPromptEvent)}
  const onInstalled=()=>{setInstalled(true);setInstallEvent(null)}
  window.addEventListener('beforeinstallprompt',onPrompt)
  window.addEventListener('appinstalled',onInstalled)
  return()=>{window.removeEventListener('beforeinstallprompt',onPrompt);window.removeEventListener('appinstalled',onInstalled)}
 },[])
 if(installed||!installEvent)return null
 return <button className="pwa-install-button" type="button" onClick={async()=>{await installEvent.prompt();const choice=await installEvent.userChoice;if(choice.outcome==='accepted')setInstallEvent(null)}}>⬇ Installa app</button>
}
